export default __webpack_public_path__ + "static/media/view_list_black_24dp.df4ecb6d.svg";